export const getSelectedTab = (menuItems: any, selectedTab: string) => {
  return menuItems.find((link: any) => `?tab=${selectedTab}` === link.link)
}
